import Text from '~/common/componentMapper/Text';
import Center from '~/common/components/Center';
import Flex from '~/common/components/Flex';

type YAMLOopsProps = {
  message?: string;
  header?: string;
};

const YAMLOops = ({
  header = ' An unexpected error has occurred.',
  message = 'Try again, or submit a CR for additional assistance if the error persists.',
}: Readonly<YAMLOopsProps>) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      data-testid="YAMLOopsError"
      sx={{
        padding: '1rem',
        minHeight: 'calc(100vh - 500px)',
      }}
    >
      <Center>
        <Text
          as="h2"
          sx={{
            fontSize: '6xl',
            fontWeight: 'bold',
            color: 'blue.700',
            mb: '1.5rem',
          }}
        >
          OOPS!
        </Text>
      </Center>
      <Center>
        <Text as="h3" sx={{ fontSize: '1xl', textAlign: 'center' }}>
          {header}
        </Text>
      </Center>
      <Center>
        <Text as="h3" sx={{ fontSize: '1xl', textAlign: 'center' }}>
          {message}
        </Text>
      </Center>
    </Flex>
  );
};

export default YAMLOops;
